import * as mutationsType from './mutationsType'

export default {
  //保存前台用户信息
  [mutationsType.RECEIVE_WEB_USER_INFO] (state, { webUserInfo }) {
    state.webUserInfo = webUserInfo
  },
  //保存后台用户信息
  [mutationsType.RECEIVE_ADMIN_USER_INFO] (state, { adminUserInfo }) {
    state.adminUserInfo = adminUserInfo
  },


  //清除前台用户信息
  [mutationsType.CLEAR_WEB_USER_INFO] (state) {
    state.webUserInfo = {}
  },

  //清除后台用户信息
  [mutationsType.CLEAR_ADMIN_USER_INFO] (state) {
    state.adminUserInfo = {}
  },

  // 更新前台token
  [mutationsType.UPDATE_WEB_TOKEN] (state,{token}) {
    state.webUserInfo.token = token
  },

  // 更新后台token
  [mutationsType.UPDATE_ADMIN_TOKEN] (state,{token}) {
    state.adminUserInfo.token = token
  },
}
